var _path, _path2, _path3, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 22,
    viewBox: "0 0 35 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 11C34.5 11.0913 34.434 11.3377 34.2014 11.7561C33.9822 12.1506 33.6509 12.6354 33.2143 13.1792C32.3421 14.2655 31.0741 15.557 29.5093 16.7954C26.3714 19.2788 22.1037 21.5 17.5 21.5C12.8963 21.5 8.62857 19.2788 5.49074 16.7954C3.92592 15.557 2.65787 14.2655 1.78568 13.1792C1.34909 12.6354 1.01784 12.1506 0.798568 11.7561C0.56603 11.3377 0.5 11.0913 0.5 11C0.5 10.9087 0.56603 10.6623 0.798568 10.2439C1.01784 9.84936 1.34909 9.36462 1.78568 8.82084C2.65787 7.73451 3.92592 6.44302 5.49074 5.20457C8.62857 2.72118 12.8963 0.5 17.5 0.5C22.1037 0.5 26.3714 2.72118 29.5093 5.20457C31.0741 6.44302 32.3421 7.73451 33.2143 8.82084C33.6509 9.36462 33.9822 9.84936 34.2014 10.2439C34.434 10.6623 34.5 10.9087 34.5 11Z",
    fill: "#F0F1F2",
    stroke: "#1C4685"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4302 10.8687C24.4302 14.3402 21.0612 17.1544 17.5004 17.1544C13.9396 17.1544 10.6244 14.3402 10.6244 10.8687C10.6244 7.39721 13.9396 4.58301 17.5004 4.58301C21.0612 4.58301 24.4302 7.39722 24.4302 10.8687Z",
    fill: "#1C4685"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4168 11.0011C20.4168 12.7022 19.111 14.0811 17.5001 14.0811C15.8893 14.0811 14.5835 12.7022 14.5835 11.0011C14.5835 9.30011 15.8893 7.92114 17.5001 7.92114C19.111 7.92114 20.4168 9.30011 20.4168 11.0011Z",
    fill: "#092F68"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.4449,
    cy: 9.68114,
    rx: 1.94444,
    ry: 1.76,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.317b552ee98ead663861a545142ba7c1.svg";
export { ForwardRef as ReactComponent };